export default function chunk(str, n) {
    let ret = [];
    let i;
    let len;

    for(i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n))
    }

    return ret
}


// WEBPACK FOOTER //
// ./src/functions/global_functions.js